module.exports = __webpack_public_path__ + "static/media/Add1.d6e05876.svg";